import { FC, memo } from 'react'
import { Dimensions, StyleSheet } from 'react-native'
import { getCustomerOrderWidth } from '../../helpers/getCustomerOrderWidth'
import ElevatedRectangle from '../UI/ElevatedRectangle'

interface CustomerOrderProps {
    code: string
    color: string | false
    textColor: string | false
}

const CustomerOrder: FC<CustomerOrderProps> = ({ code, color, textColor }) => {
    const shortCode = code.slice(-3)

    return (
        <ElevatedRectangle color={color} textColor={textColor} style={styles.container}>
            {shortCode}
        </ElevatedRectangle>
    )
}

const styles = StyleSheet.create({
    container: {
        marginBottom: 8,
        width: getCustomerOrderWidth(Dimensions.get('window').width, 6),
        margin: 3,
    },
})

export default memo(CustomerOrder)
